/* eslint-disable  @typescript-eslint/no-explicit-any */

import scope_items from './scopes';

export const environment = {
  production: true,
  authLoginUrl:
    (window as any)['env']['AUTH_LOGIN_URL'] ||
    'https:///bb-login.navigatem.de/auth',
  authApiUrl:
    (window as any)['env']['AUTH_API_URL'] || 'https:///bb-login.navigatem.de/api',
  authClientId:
    (window as any)['env']['AUTH_CLIENT_ID'] ||
    'E48B26FC-7616-EE11-A303-005056ABFA37',
  authRedirectUrl:
    (window as any)['env']['AUTH_REDIRECT_URL'] ||
    'https://bb.navigatem.de/cb',
  datafoxZKService:
    (window as any)['env']['DATAFOX_ZK_SERVICE_URL'] || 'https://bb.navigatem.de/api/v1',
  chipReverseByteOrder:
    (window as any)['env']?.['CHIP_REVERSE_BYTE_ORDER'] === 'true' || false,
  scope_items,
  featureFlags: [
    {
      id: 'clock-in-base',
      enabled: false,
    },
    {
      id: 'access-control',
      enabled: true,
    },
    {
      id: 'chip-create-delete',
      enabled: true,
    },
  ],
};
